import React, { useState, useEffect } from "react";
import { Switch as AntdSwitch, Form } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function Switch({
  label,
  name,
  checked,
  loading,
  classname,
  defaultvalue = false,
}) {
  const [values, setValues] = useState(defaultvalue);

  useEffect(() => {
    setValues(checked);
  }, [checked]);

  const onChange = (newValue) => {
    setValues(newValue);
  };

  return (
    <Form.Item
      label={label}
      name={name}
      className={`w_100_p m_0 ${classname}`}
      initialValue={defaultvalue}
    >
      <AntdSwitch
        checked={values}
        onChange={onChange}
        size={Styles.input_size}
        loading={loading}
      />
    </Form.Item>
  );
}
